import React, { useContext } from 'react';
import { ACTIONS } from '../../../../../constants';
import { DownloadReportsModel, EmployeeNodeModel } from '../../../../../models';
import { getEmployeesIds } from '../../../../../utils';
import { getActionService } from '../../../../../utils/getActionService';
import { handleDownloadReport } from '../../../../../utils/handleDownloadReport';
import { AppContext } from '../../../../context';
import { ReportItem } from '../MenuItem'; // El componente que creamos para los items de reporte

interface Props {
    startDateScheduling: string;
    selectedEmployees: EmployeeNodeModel[];
    endDateScheduling: string;
}

export const BusinessUnitMenuGroup: React.FC<Props> = ({
    endDateScheduling,
    selectedEmployees,
    startDateScheduling,
}) => {
    const { langResources, downloadReport, userInfo } = useContext(AppContext);

    /**
     * Descarga el reporte de unidades de negocio
     */
    const handlerSaveReportBusinessUnit = () => {       
        handleDownloadReport(
            startDateScheduling,
            endDateScheduling,
            getEmployeesIds(selectedEmployees),
            langResources['reports.message.alert'],
            'Programación de Unidades de Negocio',
            '/jerusalem/api/v2.0.0/reports/business-unit-scheduling',
            downloadReport
        );
    };

    const menuItems = [
        {
            action: ACTIONS['reports']['BusinessUnitScheduling'],
            label: 'Programación de Unidades de Negocio',
            handler: handlerSaveReportBusinessUnit,
        },
    ];

    return (
        <li className='nav-item px-4'>
            <a
                className='nav-link text-dark d-flex align-items-center justify-content-between'
                data-bs-toggle='collapse'
                href='#'
            >
                <span>Unidades de negocio</span>
                <i className='ri-arrow-drop-right-line fs-5'></i>
            </a>

            <div id='sidebarEcommerce' className='menu-dropdown collapse p-1'>
                <ul className='nav nav-sm flex-column px-3'>
                    {menuItems.map(
                        ({ action, label, handler }, index) =>
                            getActionService(userInfo.actions, action) && (
                                <ReportItem
                                    key={index}
                                    label={label}
                                    handler={handler}
                                />
                            )
                    )}
                </ul>
            </div>
        </li>
    );
};
